import React, { useEffect, useState } from 'react';

function DownloadHandler({ fileUrl, fileName }) {
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);

  useEffect(() => {
    // Функция для проверки, открыт ли сайт во встроенном браузере (WebView)
    const detectInAppBrowser = () => {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      
      // Проверка на WebView (особенно для Android)
      const isWebView = /; wv\)/i.test(ua) || // Классический признак WebView на Android
                        /FBAN|FBAV|Twitter|Instagram|WhatsApp|Messenger/i.test(ua); // Признаки соцсетей и мессенджеров

      // Проверяем, есть ли в user-agent упоминание WhatsApp
      const isWhatsApp = /WhatsApp/i.test(ua);

      return isWebView || isWhatsApp;
    };

    setIsInAppBrowser(detectInAppBrowser());
  }, []);

  const handleOpenInExternalBrowser = () => {
    // Пытаемся открыть ссылку во внешнем браузере через Intent (для Android)
    // Это сработает только на Android.
    const intentUrl = `intent://${fileUrl.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end;`;
    
    // Создаем невидимую ссылку и "кликаем" по ней
    const link = document.createElement('a');
    link.href = intentUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Запасной вариант: открыть в новой вкладке (иногда тоже работает)
    // window.open(fileUrl, '_blank');
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(fileUrl).then(() => {
      alert('Ссылка скопирована! Теперь откройте её в браузере Chrome или Safari.');
    }).catch(err => {
      console.error('Ошибка копирования: ', err);
    });
  };

  // Если пользователь зашел через обычный браузер (не встроенный) - просто показываем ссылку
  if (!isInAppBrowser) {
    return (
      <div>
        <a 
          href={fileUrl} 
          download // Атрибут download подсказывает браузеру скачать файл
          target="_blank" 
          rel="noopener noreferrer"
        >
          Descargar archivo
        </a>
      </div>
    );
  }

  // Если пользователь в WhatsApp или другом встроенном браузере - показываем инструкцию
  return (
    <div style={{ 
      padding: '20px', 
      border: '1px solid #f0f0f0', 
      borderRadius: '8px',
      backgroundColor: '#fff3cd',
      color: '#856404'
    }}>
      <h3>⚠️ No se puede descargar?</h3>
      <p>
        Parece que abrió esta página en el navegador integrado de WhatsApp. Para descargar el archivo, abra este enlace en un navegador normal (Chrome).
      </p>
      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
        <button 
          onClick={handleCopyLink}
          style={{
            padding: '10px 15px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          📋 Copiar el enlace
        </button>
        <button
          onClick={handleOpenInExternalBrowser}
          style={{
            padding: '10px 15px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          🌐 Abrir en el navegador
        </button>
      </div>
      <p style={{ fontSize: '0.9em', marginTop: '10px' }}>
        <small>
          Después de copiar, pega el enlace en la barra de direcciones de Chrome. O haz clic en Abrir en el navegador (funciona en Android).
        </small>
      </p>
    </div>
  );
}

export default DownloadHandler;